<template>
  <div>
    <div class="banner">
        <h4>{{ title }}</h4>
    </div>

    <v-form @submit.prevent="create" ref="form">
      <v-row dense no-gutters>
        <v-col cols="12" sm="12">
          <h5>
            <a
              href="https://www.cremeb.org.br/index.php/buscar-medicos/"
              target="_blank"
              rel="noopener noreferrer"
              class="crm-link"
            >
              Clique aqui para consultar CRM do Médico
            </a>
          </h5>
        </v-col>

        <v-col cols="12" sm="12">
          <v-text-field
            class="rounded-lg"
            color="#41916b"
            outlined
            v-model="resource.crm"
            type="number"
            :rules="formRules"
            dense
          >
            <template v-slot:label>
              CREMEB <span style="color: red;">*</span>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="12">
          <v-text-field
            class="rounded-lg"
            color="#41916b"
            outlined
            v-model="resource.name"
            :rules="formRules"
            dense
          >
            <template v-slot:label>
              Nome Profissional <span style="color: red;">*</span>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="12">
          <v-select
            :rules="formRules"
            :items="especialidades"
            v-model="specialty_id"
            item-text="description"
            item-value="id"
            color="#41916b"
            dense
            outlined
            class="rounded-lg"
            multiple
            chips
          >
            <template v-slot:label>
              Especialidades<span style="color: red;">*</span>
            </template>
          </v-select>
        </v-col>

        <v-col cols="12" sm="12">
          <v-card-actions class="cardFooter">
            <v-spacer></v-spacer>

            <v-btn
              class="rounded-lg"
              color="#e74c3c"
              text
              elevation="0"
              @click="closeDialog()"
            >
              <span>{{$t('buttons.cancel')}}</span>
            </v-btn>

            <v-btn
              class="rounded-lg"
              color="blue"
              text
              elevation="0"
              @click="$refs.form.reset()"
            >
              <span>{{$t('buttons.clean_up')}}</span>
            </v-btn>

            <v-btn
              class="rounded-lg"
              elevation="0"
              color="#41916b"
              type="submit"
              :loading="loading"
            >
              <span class="textBtn">{{ btnMessage }}</span>
              <v-icon color="#FFFFFF" small class="ml-2">
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-form> 
  </div>
</template>

<script>
import { getSpecialties, saveDoctor } from "@/service/basic-registrations/DoctorsService";
import Formatters from "@/utils/Formatters";
import { mapActions } from "vuex";
import currentUser from "@/utils/currentUser";
export default {
  data() {
    return {
        dialog: false,
        formRules: [(v) => !!v || "Campo obrigatório."],
        loading: false,
        options: {},
        sortBy: "name",
        especialidades: [],
        specialty_id: [],
      };
  },

  props: {
      resource: {
        type: Object,
      }
    },

  computed: {
    currentUser() {
      return currentUser.getUserData();
    },

    title() {
      return this.resource.id ? 'Atualizar Médico Profissional' : 'Novo Médico Profissional';
    },

    btnMessage() {
      return this.resource.id ? 'Atualizar Médico' : 'Salvar Médico';
    }
  },

  watch: {
    'resource': {
        handler(item) {
            let specialtiesIds = []
            if (item.id) {
                for (let i = 0; i < item.specialties.length; i++) {
                    specialtiesIds.push(item.specialties[i].id)
                }
            } else if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            this.specialty_id = specialtiesIds
        },
      immediate: true,
    }
  },

  methods: {
    ...mapActions([
      "changeSnackBarData",
    ]),

    loadGridData() {
      getSpecialties().then((result) => {
        this.especialidades = result;
      });
    },

    create() {
      this.loading = true;
      if (this.$refs.form.validate()) {

        const dados = this.resource
              dados.user_id = this.currentUser.id
              dados.specialty = this.specialty_id.map(id => ({
                specialty_id: id
            }));

            saveDoctor(this.resource.id || null, dados).then((response) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

            setTimeout(() => {
               if (this.$router.history.current.path == '/escala-glasgow') {
                this.$emit('closeGlasgowDialog', response.data.id.id);
               }

               this.closeDialog();
               this.closeSnackBar();
            }, 3000);
          }).catch((err) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: Formatters.formatErrorMessage(err),
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            })
            setTimeout(() => {
              this.closeSnackBar();
            }, 3000);
          });
      }
    },

    closeDialog() {
        this.$emit("closeDialog");
        this.$refs.form.resetValidation();
        this.$refs.form.reset();
        this.resource.crm = "";
        this.resource.name = "";
        this.specialty_id = [];
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    }

  },

  mounted() {
    this.loadGridData();
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  margin-bottom: 20px;
}

.space {
  width: 15px;
}
.spacediferent {
  width: 7px;
}

.unity{
  font-size: 12px;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.v-card__title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.0125em;
    font-family: 'Roboto';
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.create-user-dialog {
  padding: 20px;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}

.cardFooter {
  padding: 0 !important;
}

.crm-link {
  color: #af110c;
  text-decoration: underline;
  cursor: pointer;
  align-items: center;
}
@media (max-width: 600px) {
  .cardFooter {
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 8px;
  }

  .cardFooter .v-spacer {
    display: none;
  }

  .cardFooter .v-btn {
    width: 100%;
    margin: 0 !important;
  }
}
</style>
